import WaybillsTableColumnNumber from './index.vue'
export default WaybillsTableColumnNumber